<template>
  <div v-if="reserveActions.length" class="reserve-actions" :class="rootClass">
    <button
      type="button"
      class="button-primary primary-normal small action-button"
      :class="buttonClass"
      @click="onMainButtonClick"
    >
      {{ defaultLabel }}
    </button>

    <ReserveActionsModal
      ref="modalRef"
      :actions="reserveActions"
      @select="onSelectAction"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { BookingSummary } from '@/services/BookingService.interface'
import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'
import ReserveActionsModal from '@/components/common/ReserveActionsModal.vue'
import type { ReserveAction } from '@/utils/bookingFunnelNavigation'

const props = defineProps({
  booking: {
    type: Object as () => BookingSummary,
    required: true,
  },
  defaultLabel: {
    type: String,
    required: true,
  },
  buttonClass: {
    type: String,
    default: '',
  },
  rootClass: {
    type: String,
    default: '',
  },
})

const modalRef = ref<InstanceType<typeof ReserveActionsModal> | null>(null)

const bookingRef = () => props.booking
const {
  reserveActions,
  hasMultipleReserveActions,
  openReserveAction,
  openDefaultReserveAction,
} = useBookingFunnelNavigation(bookingRef)

const onSelectAction = async (action: ReserveAction) => {
  await openReserveAction(action)
}

const onMainButtonClick = async () => {
  if (reserveActions.value.length === 0) {
    console.error('Missing reserve navigation for booking', props.booking.reference)
    return
  }
  if (hasMultipleReserveActions.value) {
    modalRef.value?.open()
    return
  }
  await openDefaultReserveAction()
}
</script>

<style scoped>
@media (max-width: 768px) {
  .reserve-actions {
    width: 100%;
  }

  .action-button {
    width: 100%;
    max-width: 100%;
  }
}
</style>
